import PropTypes from "prop-types";
import TextInput from "@/components/common/inputs/Text_Input";
import SelectInput from "@/components/common/inputs/Select_Input";

const Input = (props) => {
  // Backward compatibility wrapper
  if (props.type === "select") {
    return <SelectInput {...props} />;
  }
  return <TextInput {...props} />;
};

Input.propTypes = {
  type: PropTypes.oneOf([
    "text",
    "password",
    "select",
    "tel",
    "email",
    "number",
  ]),
  // Other props are handled by the specific input components
};

export default Input;
